import React, { useState } from "react";
import SearchInput from "../../components/Input/SearchInputs/SearchInput";
import CustomSelect from "../../components/SelectableDropdown/CustomSelect/CustomSelect";
import DateRangePicker from "../../components/DateRangePicker/DateRangePicker";
import { Button, Col } from "antd";
import { saveAs } from "file-saver";

import {
  showErrorToast,
  showSuccessToast,
} from "../../NotificationToast/NotificationToast";
import { baseUrl } from "../../commonUtils/commonUtils";
const options = [
  {
    key: 1,
    value: "Excel",
    label: "Excel",
  },
];

const gstOptions = [
  {
    key: "all",
    value: "",
    label: "All GST",
  },
  {
    key: "true",
    value: "true",
    label: "GST: True",
  },
  {
    key: "false",
    value: "false",
    label: "GST: False",
  },
];
const CustomerHeader = ({
  handleAddCustomer,
  getAllCustomersApi,
  isFetching,
  downloadCustomersApi,
  handleSearchedValue,
  searchedValue,
  customerFilters,
  handleCustomerFilterChange,
}) => {
  const [exportSearch, setExportSearch] = useState("");
  const parentSetterState = (val) => {
    setExportSearch(val);
  };

  const customerFilterParams = {
    ...(customerFilters?.start_date && { start_date: customerFilters.start_date }),
    ...(customerFilters?.end_date && { end_date: customerFilters.end_date }),
    ...(customerFilters?.has_gst && { has_gst: customerFilters.has_gst }),
  };

  const handleChange = async (value) => {
    const downloadParams = {
      ...(exportSearch && { search: exportSearch }),
      ...customerFilterParams,
    };
    const response = await downloadCustomersApi(downloadParams);
    if (response?.error) {
      showErrorToast(response?.error?.data?.message);
    } else {
      const responseData = response?.data;
      saveAs(`${baseUrl}${responseData?.data?.url}`);
      showSuccessToast(responseData?.message);
    }
  };
  const handleDateRangeChange = (dates, dateStrings) => {
    handleCustomerFilterChange({
      start_date: dateStrings?.[0] || "",
      end_date: dateStrings?.[1] || "",
    });
  };

  const handleGstChange = (value) => {
    handleCustomerFilterChange({ has_gst: value });
  };

  return (
    <Col
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Col style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        <SearchInput
          key={`${customerFilters?.start_date}-${customerFilters?.end_date}-${customerFilters?.has_gst}`}
          size={"large"}
          placeholder={"Search by customer name, mobile no, email"}
          getLibraryApi={getAllCustomersApi}
          width={"400px"}
          isLoading={isFetching}
          parentSetterState={parentSetterState}
          handleSearchedValue={handleSearchedValue}
          searchValue={searchedValue?.search}
          queryparams={customerFilterParams}
        />
        <DateRangePicker
          onChange={handleDateRangeChange}
          format={"YYYY-MM-DD"}
        />
        <CustomSelect
          placeholder={"GST"}
          width={"130px"}
          height={"46px"}
          options={gstOptions}
          handleChange={handleGstChange}
          value={customerFilters?.has_gst || ""}
        />
        <CustomSelect
          placeholder={"Download"}
          width={"100px"}
          height={"46px"}
          options={options}
          handleChange={handleChange}
          value={"EXPORT"}
        />
      </Col>
      <Button
        type="primary"
        className="add_customer_btn"
        onClick={handleAddCustomer}
      >
        Add customer
      </Button>
    </Col>
  );
};

export default CustomerHeader;
